import './index.scss';
import videojs from 'video.js';
import 'imports-loader?videojs=video.js!../node_modules/video.js/dist/lang/en';
import 'imports-loader?videojs=video.js!../node_modules/video.js/dist/lang/ru';
import 'imports-loader?videojs=video.js!../node_modules/video.js/dist/lang/uk';

import './players/vlc-tech';
import './players/ace-tech';
import './source-handlers/html5-hlsjs-handler';
import './source-handlers/flash-flashls-handler';
import './components/hlsjs-noxbit-playlist-loader';
import './components/videojs-fill-window-toggle';

module.exports = videojs;

// Default tech order
videojs.options.techOrder = ['ace', 'vlc', 'html5', 'flash'];

// Сообщение о невозможности просмотра
videojs.options.notSupportedMessage = 'The video playback is not not supported on your browser. Consider upgrading to a web browser that supports HTML5 video or Flash.';
videojs.options.languages.en[videojs.options.notSupportedMessage] = videojs.options.notSupportedMessage;
videojs.options.languages.ru[videojs.options.notSupportedMessage] = 'Воспроизведение видео не поддерживается в вашем браузере. Рассмотрите возможность перехода на веб-браузер, поддерживающий видео в формате HTML5 или Flash.';
videojs.options.languages.uk[videojs.options.notSupportedMessage] = videojs.options.languages.ru[videojs.options.notSupportedMessage];



// WEBPACK FOOTER //
// ./src/index.js